const messages = {
  title: "Multiplicador de bónus",
  bandBonusTitle: "Bónus por pneu com multiplicador",
  amountLabel: "Nº mín. de pneus (*)",
  label: "Multiplicador de bónus",
  desc: "Número de pneus Bridgestone e Firestone. Não há bónus em euros nos pneus Firestone.",
  goals: {
    loyal: "Leal",
    bronze: "Bronze",
    silver: "Prata",
    gold: "Ouro",
    platinum: "Platina",
  },
  andMore: "e mais",
  chooseTarget: "Selecionar",
  selectTarget: "Selecione aqui o seu objetivo anual para {year}:",
  multiplication: "O bónus é multiplicado por <b>{factor}</b>",
  minTyres: "<b>Mínimo:</b> {tyre} pneus",
};

export default {
  messages,
};
